export default "__VITE_ASSET__DKZQfQ0p__"